export interface IMapMarker {
  icon?: {
    scaledSize?: { width: number; height: number };
    url?: string;
    fillColour?: string;
    strokeColour?: string;
    strokeWeight?: number;
  };
  lat: number;
  long: number;
  label?: string;
  radius?: {
    colour?: string;
    distance?: number;
  };
  draggable?: boolean;
  externalId?: any; // store whatever id to identify these things
  className?: string;
}

export interface IPolyline {
  path: { lat: number; lng: number }[];
  strokeColour?: string;
  //When true, edges of the polygon are interpreted as geodesic and will follow the curvature of the Earth. When false, edges of the polygon are rendered as straight lines in screen space. Note that the shape of a geodesic polygon may appear to change when dragged, as the dimensions are maintained relative to the surface of the earth.
  geodesic?: boolean;
}
